<template>
  <div class="user_info_form register_user">
    <h4>신청자 정보</h4>
    <p v-if="!userInfo.isCheckedIdNo" class="description">
      현금 캐시백의 경우 소득신고가 필요하며, 소득신고를 위하여 최초 1회 주민등록번호를 수집합니다.
    </p>
    <dl v-if="userInfo.isCheckedIdNo">
      <dt>사용자 유형​</dt>
      <dd>개인​</dd>
    </dl>
    <dl>
      <dt>이름</dt>
      <dd>{{ userInfo.userName }}</dd>
    </dl>
    <dl v-if="!userInfo.isCheckedIdNo || userInfo.businessType !== 1">
      <dt>주민등록번호</dt>
      <dd class="form">
        <v-input-number v-model="identityNoFront" @custom-input="checkPrevIdentityNo" maxlength="6" />
        <span></span>
        <v-input-number
          type="password"
          v-model="identityNoBack"
          maxlength="7"
          @custom-enter="handleClick"
          @custom-input="checkPrevIdentityNo"
        />
        <v-button class="btn04" @handleClick="handleClick" text="인증" :disabled="isState" />
      </dd>
      <dd class="msg" :class="msgClass">
        <v-icon clsName="icon_check" />
        <v-icon clsName="icon_error" />
        {{ errorMsg }}
      </dd>
    </dl>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VInputNumber from '@/components/atoms/VInputNumber';
import VButton from '@/components/atoms/VButton';
import VIcon from '@/components/atoms/VIcon';

export default {
  components: {
    VInputNumber,
    VButton,
    VIcon,
  },
  data() {
    return {
      errorMsg: '',
      errorCode: '',
      identityNoFront: '',
      identityNoBack: '',
      request: {},
      isState: false,
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    identityNo() {
      return this.identityNoFront + this.identityNoBack;
    },
    msgClass() {
      let className = '';
      if (this.errorCode === 0) {
        className = 'blue';
      } else if (this.errorCode > 0) {
        className = 'red';
      }
      return className;
    },
  },
  methods: {
    ...mapActions('userInfo', ['checkIdentityNo']),
    updateIdentityNo() {
      this.$emit('update', {
        request: this.isState ? this.request : '{}',
        isState: this.isState,
      });
    },
    checkPrevIdentityNo() {
      if (this.isState == true && this.request.idNo != this.identityNo) {
        this.isState = false;
        this.updateIdentityNo();
        this.errorCode = 100;
        this.errorMsg = '주민등록번호가 변경 되어 다시 인증하셔야 합니다.';
      }
    },
    async handleClick() {
      if (this.identityNo.length != 13) {
        this.errorCode = 100;
        this.errorMsg = '주민등록번호가 일치하지 않습니다.';
        return;
      }
      const apiReturn = await this.checkIdentityNo(this.identityNo);
      this.errorCode = apiReturn.code;
      if (apiReturn.code > 0) {
        this.errorMsg = '회원정보와 입력하신 주민등록번호가 일치하지 않습니다.';
      } else if (apiReturn.code === 0) {
        this.errorMsg = '주민등록번호 확인 되었습니다.';
        this.request.idNo = this.identityNo;
        this.isState = true;
        this.updateIdentityNo();
      }
    },
  },
  mounted() {
    if (this.userInfo.isCheckedIdNo) {
      this.$emit('update', {
        isState: true,
      });
    }
  },
};
</script>
<style lang="scss">
.register_user {
  .form {
    display: flex;
    align-items: center;
  }
}
</style>
